<template>
	<el-container class="wrap-80">
		<el-row>
			<BreadCrumb></BreadCrumb>
		</el-row>
		<el-row v-loading="loading" element-loading-text="加载中..." class="det-content-row">
			<MainBox :info="info" :lifeList="statusList" :standardTypeList="standardTypeList" @updateCollect="getStandardDetIsCollect"></MainBox>
			<ASide :info="info"></ASide>
		</el-row>
	</el-container>
</template>

<script>
import Y from '@/utils/Y.js';
import MainBox from './components/Mainbox.vue';
import ASide from './components/ASide.vue';
import BreadCrumb from '@/components/Breadcrumb/index.vue';
import { getStandardDet, getStandardDetIsCollect } from '@/api/standards/det.js';
import { getStandardLife, getStandardType } from '@/api/standards/search.js';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'StandardsDet',
	data() {
		return {
			info: {},
			loading: true,
			statusList: [],
			standardTypeList: []
		};
	},
	components: {
		MainBox,
		ASide,
		BreadCrumb
	},
	methods: {
		async getStandardLife() {
			let res = await getStandardLife();
			if (res.code == 200) {
				this.statusList = res.data;
				// console.log('状态列表:', this.statusList);
			}
		},
		
		async getStandardType() {
			let res = await getStandardType();
			if (res.code == 200) {
				this.standardTypeList = res.data;
			}
		},
		
		//异步fomatterLifeName
		async formatterLifeName(lifeId) {
			if (lifeId && this.statusList.length > 0) {
				const statusItem = this.statusList.find(status => status.id === lifeId);
				if (statusItem) {
					// console.log(statusItem);
					return statusItem.lifeName;
				}
			}
		},

		async getStandardDet() {
			let res = await getStandardDet(this.$route.query.id);
			this.info = res.data;
			if (this.info.paperStandardProduct) {
				this.info.paperStandardProduct.forEach((item, index) => {
					item.checked = false;
					item.curBuyNum = 1;
				});
			}
			if (this.info.digitStandardProduct) {
				this.info.digitStandardProduct.forEach((item, index) => {
					item.checked = false;
					item.curBuyNum = 1;
				});
			}
			if (this.info.jsonStandardProduct) {
				this.info.jsonStandardProduct.forEach((item, index) => {
					item.checked = false;
					item.curBuyNum = 1;
				});
			}
			// if (this.uisLogin) {
			// 	this.getStandardDetIsCollect();
			// }
			this.info.lifeName = await this.formatterLifeName(this.info.lifeId);
			this.loading = false;
			// 设置SEO相关信息
			this.setSEOInfo();
			// 将标准信息写入路由 query，供 PageFloat 反馈跳转时携带
			this.$router.replace({
				query: {
					...this.$route.query,
					standardName: this.info.standardName || '',
					standardCode: this.info.standardCode || ''
				}
			}).catch(() => {});
		},

		setSEOInfo() {
			// 设置meta信息
			let meta = ``;
			if (this.info.standardCode) {
				meta = `${this.info.standardCode} ${this.info.standardName}`;
			} else {
				meta = `${this.info.standardName}`;
			}
			this.$store.dispatch('Settings/setCurrentTitle', `${meta} - 特规通`);
			// const description = this.info.standardSummary ;
			// document.querySelector('meta[name="description"]')?.setAttribute('content', description);
		},

		//获取标准详情是否收藏
		async getStandardDetIsCollect() {
			let res = await getStandardDetIsCollect(this.$route.query.id);
			if (res.code == 200) {
				if (res.data) {
					this.$set(this.info, 'isCollect', true);
				} else {
					this.$set(this.info, 'isCollect', false);
				}
			} else {
				this.$set(this.info, 'isCollect', false);
			}
		},

		...mapActions('Settings', ['setBreadcrumbList'])
	},
	watch: {
		'$route.query.id': function () {
			this.getStandardDet();
		},
		uinfo: function (newVal, oldVal) {
			if (newVal && !oldVal) {
				// this.getStandardDetIsCollect();
				this.getStandardDet();
			}
		}
	},
	computed: {
		...mapGetters('User', ['uisLogin', 'uinfo'])
	},
	created() {
		this.getStandardDet();
		this.getStandardLife();
		this.getStandardType();
		const breadcrumbs = [
			{
				path: '/Home',
				name: '首页'
			},
			{
				path: '/StandardsList',
				name: '标准法规列表'
			},
			{
				name: '标准法规详情'
			}
		];
		this.setBreadcrumbList(breadcrumbs);
	}
};
</script>

<style lang="less" scoped>
.goods-item {
	margin-bottom: 30px;
	//padding: 10px;
	background-color: #ffffff;
	box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	border-radius: 15px;
	color: #333333;
	h4 {
		margin: 0 0 15px;
		font-weight: 400;
		font-size: 18px;
	}
}
/deep/ .el-table--border {
	border: 1px solid #d0e3f9;
	color: #686f83;
}
/deep/ .el-table thead th {
	color: #686f83;
	font-weight: 400;
}
/deep/ .el-table th.el-table__cell {
	background-color: #e3eeff;
}
/deep/ .el-table td.el-table__cell {
	border-bottom: 1px solid #d0e3f9;
}
/deep/ .el-table--border .el-table__cell {
	border-right: 1px solid #d0e3f9;
}
.nullcolor {
	color: #afb1b5;
}
//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
	.wrap-80 {
		width: 96%;
	}
	.el-card__body,
	.el-main {
		padding: 10px;
	}
}

// 小屏 MainBox 和 ASide 上下排列
@media screen and (max-width: 1024px) {
	.det-content-row {
		display: flex;
		flex-direction: column;

		> * {
			width: 100%;
			max-width: 100%;
			flex: 1 1 100%;
		}

		/deep/ .el-col {
			width: 100% !important;
			max-width: 100% !important;
			flex: 0 0 100% !important;
		}
	}
}
</style>
